// extracted by mini-css-extract-plugin
export var integrationButton = "_5y-0";